module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_yokohama-9359fb4fb3a384784a03e2864a19ef72.jpg";